import SelectPacking from 'components/BusinessLogic/Product/SelectPacking';
import Monetary from 'components/UI/Data/Monetary';
import Quality from 'components/UI/Quality';
import { memo, useRef } from 'react';
import { useBuyIntentionOfferPurchase } from 'screens/Products/components/BuyIntentionActions/useBuyIntentionOfferPurchase';
import ProductCardImage from 'screens/Products/components/ProductItem/components/ProductCardImage';
import { ModesProps } from 'screens/Products/components/ProductItem/Modes/props';
import { OfferNotes, OfferTags, useOfferSubtotal } from './OfferInfo';
import {
  OfferQuantity,
  OfferSaleTypes,
  OfferTrolleyLimit,
} from './OfferPurchaseControls';
import * as S from './offerStyles';

export const OFFER_TABLE_COLUMNS = [
  'Produto',
  'Produtor',
  'Qualidade',
  'Embalagem',
  'Tipo de venda',
  'Quantidade',
  'Subtotal',
];

function BuyIntentionOfferRow({
  product,
  packingSelected,
  handleOnSelectPacking,
  openImage,
  buy,
  selectedTypeSale,
  onChangePackingTypeSale,
}: ModesProps) {
  const rowRef = useRef<HTMLDivElement>(null);
  const purchase = useBuyIntentionOfferPurchase({
    product,
    packingSelected,
    selectedTypeSale,
    onChangePackingTypeSale,
    onClickFastBuy: buy,
    onInvalidQuantity: () =>
      rowRef.current?.scrollIntoView?.({ block: 'center', behavior: 'smooth' }),
  });
  const subtotal = useOfferSubtotal(product.id);
  const controlsProps = {
    product,
    packingSelected,
    selectedTypeSale,
    purchase,
  };

  return (
    <S.TableRow
      ref={rowRef}
      role="row"
      data-selected={purchase.quantityPacking > 0}
    >
      <S.ProductCell role="cell">
        <S.Thumb>
          <ProductCardImage
            images={product.imagesFormatted}
            imageByProducer={product.images.length > 0 && !product.isLkpOffer}
            maxHeight="48px"
            open={openImage}
          />
        </S.Thumb>
        <div>
          <S.ProductName>{product.longName}</S.ProductName>
          {product.conceptName && <S.Concept>{product.conceptName}</S.Concept>}
          <S.Secondary>
            {[product.colors, product.dimension].filter(Boolean).join(' · ')}
          </S.Secondary>
          <OfferTags product={product} />
        </div>
      </S.ProductCell>

      <S.Cell role="cell">
        {product.siteName}
        <OfferNotes product={product} />
      </S.Cell>

      <S.Cell role="cell">
        <Quality quality={product.quality} />
      </S.Cell>

      <S.Cell role="cell">
        <SelectPacking
          offerId={product.offerId}
          onSelect={handleOnSelectPacking}
          packings={product.packings}
          value={packingSelected.id}
        />
        <S.Hint>{`Múltiplo: ${packingSelected?.multiple ?? '-'}`}</S.Hint>
      </S.Cell>

      <S.Cell role="cell">
        <OfferSaleTypes {...controlsProps} />
      </S.Cell>

      <S.Cell role="cell">
        <OfferQuantity product={product} purchase={purchase} />
      </S.Cell>

      <S.Cell role="cell">
        <S.Subtotal>
          <Monetary symbol value={subtotal} />
        </S.Subtotal>
      </S.Cell>

      <OfferTrolleyLimit
        selectedTypeSale={selectedTypeSale}
        purchase={purchase}
      />
    </S.TableRow>
  );
}

export default memo(BuyIntentionOfferRow);
